import { FieldTemplate } from 'api/models';

export const usedAliases = [
  'statusz',
  'letrehozas',
  'letrehozas_m',
  'felhasznalas',
  'felhasznalas_m',
  'minta_azonosito',
  'tarolodoboz_kod',
  'doboz_sor',
  'doboz_oszlop',
];

const fields = `{
  "fields": [
    {
      "alias": "statusz",
      "fieldAttributes": {
        "label": "statusz",
        "isRequired": false,
        "options": [
          {
            "label": "Aktív",
            "value": "0"
          },
          {
            "label": "Inaktív",
            "value": "1"
          },
          {
            "label": "Felhasznált",
            "value": "2"
          }
        ],
        "isMultiSelect": false,
        "component": false
      },
      "fieldType": "select",
      "formFieldTemplateId": "6e9c26f7-214d-4302-ba52-a7a91f336b59",
      "version": 1,
      "id": "961dd91a-4e50-42fd-9832-2d4c627e5459",
      "_id": "961dd91a-4e50-42fd-9832-2d4c627e5459"
    },
    {
      "alias": "letrehozas",
      "fieldAttributes": {
        "label": "Létrehozás dátuma",
        "isRequired": false,
        "dateType": "YYYY.MM.DD",
        "cantBeEarlierThanBirthDate": false,
        "cantBeLaterThanVisitDate": false
      },
      "fieldType": "date",
      "formFieldTemplateId": "855276e7-98bb-405d-ba61-585af3b596ad",
      "version": 1,
      "id": "b23f5027-0cad-48ba-b61b-12303049db6a",
      "_id": "b23f5027-0cad-48ba-b61b-12303049db6a"
    },
    {
      "alias": "letrehozas_m",
      "fieldAttributes": {
        "label": "Létrehozás megjegyzés",
        "isRequired": false
      },
      "fieldType": "text",
      "formFieldTemplateId": "d5ccc375-e074-4b21-a0d8-8d4b41eb0f70",
      "version": 1,
      "id": "07d1a0ef-854f-461d-b3c7-50433f6e1b5d",
      "_id": "07d1a0ef-854f-461d-b3c7-50433f6e1b5d"
    },
    {
      "alias": "felhasznalas",
      "fieldAttributes": {
        "label": "Felhasználás dátuma",
        "isRequired": false,
        "dateType": "YYYY.MM.DD",
        "cantBeEarlierThanBirthDate": false,
        "cantBeLaterThanVisitDate": false
      },
      "fieldType": "date",
      "formFieldTemplateId": "2e89fbe4-0e0f-4484-984b-cf6df1dbe1b7",
      "isVisible": {
        "type": "conditionGroup",
        "operation": "and",
        "conditions": [
          {
            "type": "conditionGroup",
            "operation": "and",
            "conditions": [
              {
                "operation": "IS_ANY_OF",
                "value": ["1", "2"],
                "type": "condition",
                "reference": {
                  "type": "formFieldReference",
                  "alias": "statusz",
                  "attribute": "",
                  "valueType": "stringlist"
                }
              }
            ]
          }
        ]
      },
      "version": 1,
      "id": "2a05f707-5b5c-407a-9848-535d190a50b3",
      "_id": "2a05f707-5b5c-407a-9848-535d190a50b3"
    },
    {
      "alias": "felhasznalas_m",
      "fieldAttributes": {
        "label": "Felhasználás megjegyzés",
        "isRequired": false
      },
      "fieldType": "text",
      "formFieldTemplateId": "ee4d076f-0e0a-4d7d-9ada-a4ecbddbd46b",
      "isVisible": {
        "type": "conditionGroup",
        "operation": "and",
        "conditions": [
          {
            "type": "conditionGroup",
            "operation": "and",
            "conditions": [
              {
                "operation": "IS_ANY_OF",
                "value": ["1", "2"],
                "type": "condition",
                "reference": {
                  "type": "formFieldReference",
                  "alias": "statusz",
                  "attribute": "",
                  "valueType": "stringlist"
                }
              }
            ]
          }
        ]
      },
      "version": 1,
      "id": "f5f3adf8-6075-4db2-8820-6600c2cc8985",
      "_id": "f5f3adf8-6075-4db2-8820-6600c2cc8985"
    },
    {
      "alias": "minta_azonosito",
      "fieldAttributes": {
        "label": "Minta azonosító",
        "isRequired": false
      },
      "fieldType": "number",
      "formFieldTemplateId": "bc7a56a9-933c-4e01-8271-2def27dea993",
      "version": 1,
      "id": "291a266e-cc28-4a60-9cb3-f6715f2c76f5",
      "_id": "291a266e-cc28-4a60-9cb3-f6715f2c76f5"
    },
    {
      "alias": "tarolodoboz_kod",
      "fieldAttributes": {
        "label": "Tárolódoboz kód",
        "isRequired": false
      },
      "fieldType": "text",
      "formFieldTemplateId": "b6cf2d7e-afbf-4710-8af0-041691e5b49e",
      "version": 1,
      "id": "acb1152e-db7b-40b9-a8d8-8da588a8e58b",
      "_id": "acb1152e-db7b-40b9-a8d8-8da588a8e58b"
    },
    {
      "alias": "doboz_sor",
      "fieldAttributes": {
        "label": "Doboz sor",
        "isRequired": false
      },
      "fieldType": "number",
      "formFieldTemplateId": "a20b3bfc-f01c-4b15-9fb5-cee074ab8d6f",
      "version": 1,
      "id": "e9ddb995-ab4a-42dc-8589-c580d4703e6f",
      "_id": "e9ddb995-ab4a-42dc-8589-c580d4703e6f"
    },
    {
      "alias": "doboz_oszlop",
      "fieldAttributes": {
        "label": "Doboz oszlop",
        "isRequired": false
      },
      "fieldType": "number",
      "formFieldTemplateId": "55e64255-c798-4a6b-83de-761bf2911e74",
      "version": 1,
      "id": "c0390830-1627-4646-9fa1-b2ad601ba994",
      "_id": "c0390830-1627-4646-9fa1-b2ad601ba994"
    }
  ]
}`;

export function getSampleFields() {
  return JSON.parse(fields).fields as FieldTemplate[];
}
